import React from 'react';
import AbilityButton from './AbilityButton';
import PassiveButton from './PassiveButton';
import { SimplifiedSpell } from '../../../../../gameTypes';

import './AbilityButtons.css';
import { championImages } from '../ComboDisplay/Events/Images/championImages';

interface AbilityButtonsProps {
  championName: string;                            // <-- add championName prop
  spellImageUrls: Record<string, string>;
  autoAttackImageUrl: string;
  passiveImageUrl: string; 
  abilities: SimplifiedSpell[];
  onAbilityClick: (abilityKey: string) => void;
}

const AbilityButtons: React.FC<AbilityButtonsProps> = ({
  championName,
  spellImageUrls,
  autoAttackImageUrl,
  passiveImageUrl,
  abilities,
  onAbilityClick
}) => {
  // Q, W, E, R order
  const abilityKeyMap = ['Q', 'W', 'E', 'R'];

  // Attempt to fetch the champion's image map from championImages
  const champMap = championImages[championName] || {};

  return (
    <div className="ability-buttons-container">

      {/* Passive Button */}
      <PassiveButton passiveImage={passiveImageUrl} />

      {/* For each ability */}
      {abilities.map((spell, index) => {
        const abilityKey = abilityKeyMap[index];
        
        // 1) if spell.imageState != 'default', try championImages[championName][imageState]
        let finalImage: string | undefined;

        if (spell.imageState && spell.imageState !== 'default') {
          const lowerState = spell.imageState.toLowerCase();
          finalImage = champMap[lowerState];
        }

        // 2) If still no image found, fallback to the "old" approach:
        if (!finalImage) {
          // E.g. imageKey approach from your code
          const imageKey = spell.imageState && spellImageUrls[spell.imageState]
            ? spell.imageState
            : abilityKey;
          finalImage = spellImageUrls[imageKey] || spellImageUrls[abilityKey];
        }

        return (
          <AbilityButton
            key={abilityKey}
            abilityKey={abilityKey}
            abilityImage={finalImage}
            spell={spell}
            onClick={() => onAbilityClick(abilityKey)}
          />
        );
      })}

      {/* Auto-Attack Button */}
      <AbilityButton
        abilityKey="A"
        abilityImage={autoAttackImageUrl}
        spell={{
          name: 'Auto Attack',
          description: 'Basic attack',
          cooldown: 0,
          remainingCooldown: 0,
          cooldownDurations: [],
          isOnCooldown: false,
          damage: [],
          manaCost: [],
          scalings: [],
          pointsInSpell: 0,
          imageState: "default"
        }}
        isAutoAttack={true}
        onClick={() => onAbilityClick('A')}
      /> 
    </div>
  );
};

export default AbilityButtons;
